"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountProfileSave = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackCustomerAccountProfileSave(selected_gender) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickButton,
        feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
        click_element: 'Safe customer information',
        click_text: 'Speichern',
        selected_gender,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.CustomerAccount,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: 'Safe customer information',
        eventData,
    });
}
exports.trackCustomerAccountProfileSave = trackCustomerAccountProfileSave;
//# sourceMappingURL=trackCustomerAccountProfileSave.js.map